// Dependencies
import React from 'react';
import radium from 'radium';
import Section from '../../components/section/Section.jsx';
import { ThemeContext } from '../../components/theme/Theme.jsx';

function HelpInfo() {
	const context = React.useContext(ThemeContext);
	const style = {
		box: {
			margin: context.themeManager
				.value('help-info-box', 'margin-mobile', 'section-margin-mobile'),
			padding: '2em',
			textAlign: 'center',
			textTransform: 'uppercase',
			fontSize: context.themeManager.value('help-info-box', 'fontSize', 'font-size-300'),
			backgroundColor: context.themeManager.value('help-info-box',
				'backgroundColor', 'bg-color-box'),
			'@media(min-width : 768px)': {
				margin: context.themeManager
					.value('help-info-box', 'margin-mobile', 'section-margin-desktop'),
			},
		},

		innerBox: {
			lineHeight: context.themeManager.value('help-info-box', 'lineHeight', 'line-height-200'),
			'@media(min-width : 768px)': {
				padding: '2em',
			},
		},
	};

	return (
		<Section style={style.box}>
			<div
				style={style.innerBox}
				dangerouslySetInnerHTML={{ __html: context.themeManager.getThemeText('help') }}
			/>
		</Section>
	);
}

export default radium(HelpInfo);
